import { defineEvent } from '../types/event';
export var CUSTOMER_ACTIVATE = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'customerActivate'
        },
        {
            name: 'GTM',
            alias: 'customerActivate'
        }
    ]
});
